export default __webpack_public_path__ + "static/media/Success.211d67c9.svg";